export default __webpack_public_path__ + "static/media/a9.a52bf40c.jpg";